import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { CanvasAPI } from '@/api/canvas'
import { Trans } from '@/components'
import { formatCompactNumber, formatDecimalString } from '@/utils/formatter'

import { fetchModelRouteKpi } from '../api'
import { KpiCard } from './KpiCard'
import { ModelRouteRechargeModal } from './ModelRouteRechargeModal'

export function ModelRouteKpiPanel() {
  const navigate = useNavigate()
  const [rechargeOpen, setRechargeOpen] = useState(false)

  const { data } = useQuery({
    queryKey: ['modelRouteKpi'],
    queryFn: fetchModelRouteKpi,
  })

  // Shares the query key with the recharge modal so a transfer refreshes both.
  const { data: canvasBilling } = useQuery({
    queryKey: ['modelRouteBillingSummary'],
    queryFn: () => CanvasAPI.getProjectBillingSummary(),
  })
  const balance = canvasBilling?.summary?.balance_credits

  // Balance card is always shown: it is the recharge entry point.
  const hasRoutes = !!data && data.totalRoutes > 0

  return (
    <>
      <div className="card bg-panel-white flex-shrink-0">
        <div className="grid grid-cols-5 gap-4">
          <KpiCard
            label={
              <Trans ns="modelRoute" i18nKey="kpi.balance">
                Balance (Credit)
              </Trans>
            }
            value={balance !== undefined ? formatDecimalString(balance, 3, 3) : '-'}
            onClick={() => setRechargeOpen(true)}
          />
          <KpiCard
            label={
              <Trans ns="modelRoute" i18nKey="kpi.avgResponse">
                Avg Response
              </Trans>
            }
            value={hasRoutes ? `${data.avgResponseSec}s` : '-'}
          />
          <KpiCard
            label={
              <Trans ns="modelRoute" i18nKey="kpi.todayRequests">
                Today Requests
              </Trans>
            }
            value={hasRoutes ? formatCompactNumber(data.todayRequests) : '-'}
          />
          <KpiCard
            label={
              <Trans ns="modelRoute" i18nKey="kpi.todayTokens">
                Today Tokens
              </Trans>
            }
            value={hasRoutes ? formatCompactNumber(data.todayTokens) : '-'}
          />
          <KpiCard
            label={
              <Trans ns="modelRoute" i18nKey="kpi.todayCost">
                Today Cost (Credit)
              </Trans>
            }
            value={hasRoutes ? data.todayCost : '-'}
            onClick={() => navigate('/model-route/billing?range=today')}
          />
        </div>
      </div>

      {rechargeOpen && <ModelRouteRechargeModal onClose={() => setRechargeOpen(false)} />}
    </>
  )
}
